<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- generalInformation -->
      <section>
        <fieldset formGroupName="generalInformation">
          <legend>
            {{ pageVocabs + "legends.generalInformation" | translate }}
          </legend>

          <div class="row">
            <!-- name -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.name"
                [control]="form?.get('generalInformation.name')"
                label="common.name"
              >
              </form-field>
            </div>

            <!-- defaultNumber -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.defaultNumber"
                [control]="form?.get('generalInformation.defaultNumber')"
                [label]="fields + 'defaultNumber'"
              >
              </form-field>
            </div>

            <!-- type -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                enumName="SenderAgentType"
                [label]="fields + 'type'"
                [control]="form?.get('generalInformation.type')"
                [(value)]="model.type"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- smsSenderAgentReference -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                enumName="SmsCp"
                [label]="fields + 'smsSenderAgentReference'"
                [control]="
                  form?.get('generalInformation.smsSenderAgentReference')
                "
                [(value)]="model.smsSenderAgentReference"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- receiveInboxType -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                enumName="ReceiveInboxType"
                [label]="fields + 'receiveInboxType'"
                [control]="form?.get('generalInformation.receiveInboxType')"
                [(value)]="model.receiveInboxType"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- startTime -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <timepicker
                [value]="startSendTime"
                (value)="startSendTime = $event"
                [control]="form?.get('generalInformation.startTime')"
                [maxTime]="endVal"
                [confirmBtnClass]="'btn' | themeColor"
              >
              </timepicker>
            </div>

            <!-- endTime -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <timepicker
                [value]="endSendTime"
                (value)="endSendTime = $event"
                [control]="form?.get('generalInformation.endTime')"
                label="common.endTime"
                [minTime]="startVal"
                [confirmBtnClass]="'btn' | themeColor"
              >
              </timepicker>
            </div>

            <!-- sendBulkIsAutomatic -->
            <!-- <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle formControlName="sendBulkIsAutomatic" [(ngModel)]="model.sendBulkIsAutomatic">
                {{fields+'sendBulkIsAutomatic'|translate}}
              </mat-slide-toggle>
            </div> -->
          </div>

          <div class="row">
            <!-- isSendActive -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle
                formControlName="isSendActive"
                [(ngModel)]="model.isSendActive"
              >
                {{ fields + "isSendActive" | translate }}
              </mat-slide-toggle>
            </div>

            <!-- isReceiveActive -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle
                formControlName="isReceiveActive"
                [(ngModel)]="model.isRecieveActive"
              >
                {{ fields + "isReceiveActive" | translate }}
              </mat-slide-toggle>
            </div>

            <!-- isSendBulkActive -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle
                formControlName="isSendBulkActive"
                [(ngModel)]="model.isSendBulkActive"
              >
                {{ fields + "isSendBulkActive" | translate }}
              </mat-slide-toggle>
            </div>

            <!-- checkMessageId -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle
                formControlName="checkMessageId"
                [(ngModel)]="model.checkMessageId"
              >
                {{ fields + "checkMessageId" | translate }}
              </mat-slide-toggle>
            </div>

            <!-- isSendSmartActive -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle
                formControlName="isSendSmartActive"
                [(ngModel)]="model.isSendSmartActive"
              >
                {{ fields + "isSendSmartActive" | translate }}
              </mat-slide-toggle>
            </div>

            <!--isActiveAllTime-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle
                (change)="changeIsActiveAll($event)"
                formControlName="isActiveAllTime"
                [(ngModel)]="model.isActiveAllTime"
              >
                {{ fields + "isActiveAllTime" | translate }}</mat-slide-toggle
              >
            </div>
          </div>
        </fieldset>
      </section>

      <!-- accessInformation -->
      <section class="tw-mt-5">
        <fieldset formGroupName="accessInformation">
          <legend>
            {{ pageVocabs + "legends.accessInformation" | translate }}
          </legend>

          <div class="row">
            <!-- username -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.username"
                [control]="form?.get('accessInformation.username')"
                label="common.userName"
              >
              </form-field>
            </div>

            <!-- passwordOrToken -->
            <div class="md:tw-w-2/3 xl:tw-w-3/4">
              <form-field
                class="tw-w-full"
                label="common.passwordOrToken"
                [maxLength]="500"
                [control]="form?.get('accessInformation.password')"
                [type]="hidePassword ? 'password' : 'text'"
                [(value)]="model.password"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- domain -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.domain"
                [control]="form?.get('accessInformation.domain')"
                [label]="fields + 'domain'"
              >
              </form-field>
            </div>

            <!-- queueLength -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.queueLength"
                type="number"
                [control]="form?.get('accessInformation.queueLength')"
                [label]="fields + 'queueLength'"
                [min]="1"
                [max]="100000"
              >
              </form-field>
            </div>

            <!-- udhLen -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <custom-select-search
                [label]="fields + 'udhLen'"
                [items]="finalUdhlenValues"
                [control]="form?.get('accessInformation.udhLen')"
                optionTitle="value"
                optionValue="value"
                [removable]="false"
                [(value)]="model.udhLen"
              >
              </custom-select-search>
            </div>

            <!-- sendLink -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.sendLink"
                [control]="form?.get('accessInformation.sendLink')"
                [label]="fields + 'sendLink'"
              >
              </form-field>
            </div>

            <!-- receiveLink -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.receiveLink"
                [control]="form?.get('accessInformation.receiveLink')"
                [label]="fields + 'receiveLink'"
              >
              </form-field>
            </div>

            <!-- deliveryLink -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.deliveryLink"
                [control]="form?.get('accessInformation.deliveryLink')"
                [label]="fields + 'deliveryLink'"
              >
              </form-field>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- SocialMediaSmartDetailsMci -->
      <section class="tw-mt-5" *ngIf="model.smsSenderAgentReference == SmsCp.Mxb">
        <fieldset formGroupName="socialMediaSmartDetails">
          <legend class="tw-flex tw-items-center">
            <div
              class="tw-py-[2px] tw-bg-white tw-rounded-md tw-ml-[10px] ltr:tw-mr-[10px] tw-h-[32px]"
            >
              <img
                class="tw-mx-3 hide-in-sm"
                [smsAggregatorImage]="'MCI'"
                width="25"
              />
            </div>
            <span>{{
              pageVocabs + "legends.socialMediaSmartDetailsMci" | translate
            }}</span>
          </legend>

          <div class="row">
            <!-- token -->
            <div class="md:tw-w-2/3 xl:tw-w-3/4">
              <form-field
                class="tw-w-full"
                label="common.token"
                [maxLength]="500"
                [classList]="'dir-lg'"
                [control]="form?.get('tokenMci')"
                [(value)]="tokenMci"
              >
              </form-field>
            </div>

            <!-- url -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="urlMci"
                [control]="form?.get('socialMediaSmartDetails.urlMci')"
                [label]="'common.url'"
              >
              </form-field>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- SocialMediaSmartDetailsMtn -->
      <section class="tw-mt-5" *ngIf="model.smsSenderAgentReference == SmsCp.Mxb">
        <fieldset formGroupName="socialMediaSmartDetails">
          <legend class="tw-flex tw-items-center">
            <div
              class="tw-py-[2px] tw-bg-white tw-rounded-md tw-ml-[10px] ltr:tw-mr-[10px] tw-h-[32px]"
            >
              <img
                class="tw-mx-3 hide-in-sm"
                [smsAggregatorImage]="'Irancell'"
                width="25"
              />
            </div>
            <span>
              {{
                pageVocabs + "legends.socialMediaSmartDetailsMtn" | translate
              }}
            </span>
          </legend>

          <div class="row">
            <!-- token -->
            <div class="md:tw-w-2/3 xl:tw-w-3/4">
              <form-field
                class="tw-w-full"
                label="common.token"
                [maxLength]="500"
                [classList]="'dir-lg'"
                [control]="form?.get('tokenMtn')"
                [(value)]="tokenMtn"
              >
              </form-field>
            </div>

            <!-- url -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="urlMtn"
                [control]="form?.get('socialMediaSmartDetails.urlMtn')"
                [label]="'common.url'"
              >
              </form-field>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- SocialMediaSmartDetailsRightel -->
      <section class="tw-mt-5" *ngIf="model.smsSenderAgentReference == SmsCp.Mxb">
        <fieldset formGroupName="socialMediaSmartDetails">
          <legend class="tw-flex tw-items-center">
            <div
              class="tw-py-[2px] tw-bg-white tw-rounded-md tw-ml-[10px] ltr:tw-mr-[10px] tw-h-[32px]"
            >
              <img
                class="tw-mx-3 hide-in-sm"
                [smsAggregatorImage]="'Rightel'"
                width="35"
              />
            </div>
            <span>
              {{
                pageVocabs + "legends.socialMediaSmartDetailsRightel"
                  | translate
              }}</span
            >
          </legend>

          <div class="row">
            <!-- token -->
            <div class="md:tw-w-2/3 xl:tw-w-3/4">
              <form-field
                class="tw-w-full"
                label="common.token"
                [maxLength]="500"
                [classList]="'dir-lg'"
                [control]="form?.get('tokenRightel')"
                [(value)]="tokenRightel"
              >
              </form-field>
            </div>

            <!-- url -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="urlRightel"
                [control]="form?.get('socialMediaSmartDetails.urlRightel')"
                [label]="'common.url'"
              >
              </form-field>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
